"use strict";
/**
 * 行业正文 和策略报告正文公用 热门行业
 *
 *  */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var index_1 = __importDefault(require("./index"));
var webconfig = require('../../../config/web.js');
var hothy_table = /** @class */ (function (_super) {
    __extends(hothy_table, _super);
    function hothy_table() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    hothy_table.prototype.getDataAjax = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this, sortFiles, url;
            return __generator(this, function (_a) {
                _this = this;
                sortFiles = params.fid;
                url = webconfig.getWebPath('quoteurl') + 'api/qt/clist/get?pn=1&pz=15&po=1&np=1&fltt=2&invt=2&ut=8dec03ba335b81bf4ebdf7b29ec27d15&cb=?';
                return [2 /*return*/, $.ajax({
                        url: url,
                        type: 'GET',
                        dataType: 'jsonp',
                        data: params
                    }).then(function (res) {
                        var diff = res.data.diff;
                        var data = {};
                        data['data'] = [];
                        for (var i = 0; i < diff.length; i++) {
                            var element = diff[i];
                            var value = element[sortFiles];
                            var zdf = element['f3'];
                            var obj = {
                                zdf: zdf == '-' ? '-' : Number(zdf).toFixed(2),
                                name: element['f14'],
                                code: element['f12'],
                                lzgp: element['f128'],
                                stockcode: element['f140'],
                                quoteid: element['f141'] + '.' + element['f140'],
                                value: value
                            };
                            data['data'].push(obj);
                        }
                        ;
                        // console.log(data)
                        return data;
                    })];
            });
        });
    };
    ;
    return hothy_table;
}(index_1["default"]));
exports["default"] = hothy_table;
